import React from "react";
import ReactDOM from "react-dom/client";
// react-router 8 deleted the react-router-dom package; RouterProvider is the
// one export that did not fold into the root entry point.
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { App } from "./App";
import "./index.css";

const router = createBrowserRouter([
    {
        path: "/*",
        element: <App />
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
